import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Edit } from 'jbc-front/components/icons';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import { Grid } from '@/components/ui/Grid';
import { Dd, Dl, Dt } from '@/components/ui/DefinitionList';
import { displayFormat } from '@/components/utils/formatter';
import { ViewProps } from './ViewProps';

export const HealthCheckupInstitution: FC<ViewProps> = ({ result, editLink }) => {
  return (
    <Panel>
      <Link to={`${editLink}#health_checkup_institution`}>
        <Headding icon={<Edit icon={16} />}>健康診断実施機関</Headding>
      </Link>
      <Item>
        <Grid>
          <Dl>
            <Dt>名称</Dt>
            <Dd>{displayFormat(result.healthCheckupInstitution?.name)}</Dd>
          </Dl>
          <Dl>
            <Dt>所在地</Dt>
            <Dd>{displayFormat(result.healthCheckupInstitution?.location)}</Dd>
          </Dl>
        </Grid>
      </Item>
    </Panel>
  );
};
